
<template>
  <v-content class="db-content">
    <v-flex class="space2"></v-flex>
    <div class="navigate">
      <v-container>
        <v-layout row wrap>
          <v-flex sm6 xs6 md6 lg6>
            <v-btn
              class="ma-2"
              outlined
              color="teal"
              value="Go Back From Whence You Came!"
              onclick="history.back(-1)"
              >Previous Page</v-btn
            >
          </v-flex>
          <v-flex sm6 xs6 md6 lg6>
            <QuotesPopup
              class="ma-2"
              outlined
              color="teal"
              onclick=""
              style="float: right"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-container grid-list-xl class="lighten-3">
      <v-flex class="space1"></v-flex>
      <v-flex xs12 sm12 md24 x24 class="lg5-custom">
        <v-card class="padding1">
          <v-column>
            <v-row>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  QUOTE
                </div>
              </v-col>
              <v-col>
                <div
                  class="title font-weight-light mb-2"
                  style="color: #ffffff; text-align: right"
                ></div>
              </v-col>
            </v-row>
          </v-column>
          <v-divider class="my-2"></v-divider>
          <div class="spacer" />
          <div class="spacer" />
          <div
            class="display-4 font-weight-bold mb-2"
            style="color: #111; text-align: center"
          ></div>
          <div class="spacer" />
          <v-column>
            <v-row> </v-row>
          </v-column>
          <v-column>
            <v-row>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  TO:
                </div>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                >
                  Macheenist
                </div>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                >
                  14429 Ventura Blvd. Ste. 109
                </div>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                >
                  Sherman Oaks, CA 91423
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  FROM:
                </div>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                >
                  Cell Funds
                </div>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                >
                  14429 Ventura Blvd. Ste. 108
                </div>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                >
                  Sherman Oaks, CA 91423
                </div>
              </v-col>
            </v-row>
          </v-column>
          <v-column>
            <v-flex class="space3"></v-flex>
            <v-row>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: center"
                >
                  Quantity
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  Description
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  Price
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  Total
                </div>
              </v-col>
            </v-row>
          </v-column>
          <div class="spacer" />
          <div class="spacer" />
          <v-divider class="my-2"></v-divider>
          <v-column>
            <v-flex class="space4"></v-flex>
            <v-row>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                >
                  2
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: left"
                >
                  iPhone 11 64gb
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: left"
                >
                  $550.00
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: left"
                >
                  $1,100.00
                </div>
              </v-col>
            </v-row>
          </v-column>

          <v-divider class="my-2"></v-divider>
          <v-column>
            <v-flex class="space4"></v-flex>
            <v-row>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                >
                  2
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: left"
                >
                  iPhone 11 64gb
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: left"
                >
                  $550.00
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: left"
                >
                  $1,100.00
                </div>
              </v-col>
            </v-row>
          </v-column>

          <v-divider class="my-2"></v-divider>
          <v-column>
            <v-flex class="space4"></v-flex>
            <v-row>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                ></div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: left"
                ></div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  Subtotal
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  $2,200.00
                </div>
              </v-col>
            </v-row>
          </v-column>

          <v-divider class="my-2"></v-divider>
          <v-column>
            <v-flex class="space4"></v-flex>
            <v-row>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                ></div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: left"
                ></div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  Taxes
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  $210.00
                </div>
              </v-col>
            </v-row>
          </v-column>

          <v-divider class="my-2"></v-divider>
          <v-column>
            <v-flex class="space4"></v-flex>
            <v-row>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                ></div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: left"
                ></div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  Total
                </div>
              </v-col>
              <v-col>
                <div
                  class="headline font-weight-heavy mb-2"
                  style="color: #111; text-align: left"
                >
                  $2,410.00
                </div>
              </v-col>
            </v-row>
          </v-column>

          <v-divider class="my-2"></v-divider>
          <v-column>
            <v-flex class="space4"></v-flex>
            <v-row>
              <v-col>
                <div
                  class="headline font-weight-light mb-2"
                  style="color: #111; text-align: center"
                >
                  Made with Cogneetiv AI Assistant
                </div>
              </v-col>
            </v-row>
          </v-column>

          <div
            class="display-4 font-weight-bold mb-2"
            style="color: #111; text-align: center"
          ></div>
          <div class="spacer" />
          <v-column>
            <v-row> </v-row>
          </v-column>
        </v-card>
      </v-flex>
    </v-container>
    <v-flex class="space5"></v-flex>
  </v-content>
</template>


<script>
import QuotesPopup from "@/components/QuotesPopup.vue";

export default {
  name: "quotes",
  data() {
    return {
      // dialog: false,
      items: [],
      absolute: true,
      overlay: false,
      currentField: 0, // You forgot to initialize this variable
      company: "",
      contact: "",
      address: "",
      city: "",
      zipcode: "",
      quote: "",
      quoteDate: "",
      quoteDue: "",
      search: "",
      headers: [
        {
          text: "Company",
          align: "left",
          filterable: false,
          value: "company",
        },
        { text: "Contact", value: "contact" },
        { text: "Address", value: "address" },
        { text: "City", value: "city" },
        { text: "Zip Code", value: "zipcode" },
        { text: "Quote", value: "quote" },
        { text: "Quote Date", value: "quoteDate" },
        { text: "Quote Due", value: "quoteDue" },
      ],

      quotesList: [],
    };
  },

  components: {
    // CalendarPicker,
    // Form,
    QuotesPopup,
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    openForm: () => {
      // this.dialog = true;
      this.overlay = true;
    },
    readOutLoud: function (msg) {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      this.speak = msg;
      speech.onend = function () {
        Event.$emit("speakModeOn");
      };
    },
    fillForm: function (msg) {
      switch (this.currentField) {
        case 0:
          this.company = msg;
          break;
        case 1:
          this.contact = msg;
          break;
        case 2:
          this.address = msg;
          break;
        case 3:
          this.city = msg;
          break;
        case 4:
          this.zipcode = msg;
          break;
        case 5:
          this.quote = msg;
          break;
        case 6:
          this.quoteDate = msg;
          break;
        case 7:
          this.quoteDue = msg;
          break;
      }

      this.currentField++;
      this.navigateField();
    },
    navigateField: function () {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud("Company Name?");
          break;
        case 1:
          this.readOutLoud("Who is the main contact?");
          break;
        case 2:
          this.readOutLoud("What is the billing address?");
          break;
        case 3:
          this.readOutLoud("City?");
          break;
        case 4:
          this.readOutLoud("Zipcode?");
          break;
        case 5:
          this.readOutLoud("What is the total due on Quote?");
          break;
        case 6:
          this.readOutLoud("Quote Date?");
          break;
        case 7:
          this.readOutLoud("Quote Due?");
          break;
      }
    },
    showAlert() {
      // Use sweetalert2
      this.$swal("Hello Vue world!!!");
    },

    getQuoteList: async function () {
      const response = await fetch("https://www.cogneetiv.com/api/fetchquote");
      const json = await response.json();
      console.log(json);
      this.quotesList = json.data;
    },

    submitForm: async function () {
      let reqParams = {
        company: this.company,
        contact: this.contact,
        address: this.address,
        city: this.city,
        zipcode: this.zipcode,
        quote: this.quote,
        quoteDate: this.quoteDate,
        quoteDue: this.quoteDue,
      };
      const response = await fetch(
        "https://www.cogneetiv.com/api/createquote",
        {
          method: "POST",
          body: JSON.stringify({ ...reqParams }), // string or object
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud("Voice Form Submitted successfully!");
        this.$swal(
          "Good job!",
          "Voice Form Submitted successfully!",
          "success"
        );
        this.getQuoteList();
      }, 800);
    },
  },
  mounted() {
    // this.readOutLoud("Welcome John!!");
    this.getQuoteList();
    Event.$off("openForm"); // add this to remove multiple event trigger
    Event.$on("openForm", (data) => {
      // Event.$off();
      if (this.$route.path !== "/quotegenerator") {
        return;
      }
      console.log("open quote generator", data);
      //   this.$router.push({ name: "quotegenerator" });
      this.readOutLoud("Please fill the following details");
      setTimeout(() => {
        this.readOutLoud("What's the company name?");
      }, 1000);
      this.overlay = true;
    });
    Event.$off("formDetails"); // add this to remove multiple event trigger
    Event.$on("formDetails", (data) => {
      console.log(data);

      switch (data.msg) {
        case "next":
          this.currentField++;
          this.navigateField();

          break;
        case "previous":
          this.currentField--;
          this.navigateField();

          break;
        case "submit":
          this.readOutLoud("Please verify your details");
          break;
        case "verified":
          this.overlay = false;
          this.submitForm();
          break;
        default:
          this.fillForm(data.msg);
          break;
      }
    });
  },
  beforeDestroy() {
    Event.$off("openForm"); // add this to remove multiple event trigger
  },
};
</script>

<style scoped>
.theme-bg {
  background: #5351a0;
  color: #fff;
}

.space1 {
  height: 15px;
}

.space2 {
  height: 25px;
}

.space3 {
  height: 45px;
}
.space4 {
  height: 20px;
}
.space5 {
  height: 200px;
}
.margin1 {
  margin: 20px;
}

.padding1 {
  padding: 40px;
}

.db-content {
  background: #171642;
  height: 150vh;
}
.close-btn {
  position: absolute;
  right: 0px;
  margin-top: -60px;
}
h3 {
  color: #888;
}
.title-text {
  font-size: 24px;
  margin: 10px;
}
</style>
